import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import colors from '../../../../constants/colors';
import Accordion from 'app/components/Accordion';
import { desktopMinWidth } from '../../../../../utils/windowHelpers';

const Attributes = ({ attributes }) => {
  const useStyles = makeStyles(theme =>
    createStyles({
      root: {},
      detailContainer: {
        paddingTop: 18,
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gridGap: '16px',
        griAutoRows: '32px',
        [desktopMinWidth]: {
          paddingTop: 24,
        },
      },
      header: {
        fontSize: 16,
        color: colors.white_f2,
        fontWeight: 500,
        paddingBottom: 8,
        borderBottom: '1px solid #666666',
      },
      rowCard: {
        gridColumn: 'auto / span 3',
        padding: '24px 12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        borderRadius: 4,
        background: '#25273D',
      },
      rowKey: {
        fontSize: 12,
        color: colors.gray_aa,
        fontWeight: 500,
        textTransform: 'uppercase',
        marginBottom: 12,
      },
      rowValue: {
        fontSize: 14,
        color: colors.white_f2,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: 110,
      },
    }),
  );
  const classes = useStyles();
  return (
    <div>
      <Accordion
        isOpened={true}
        transitionTime={150}
        closedIconName="arrow-white-close"
        openIconName="arrow-white-open"
        trigger={<div className={classes.header}>Attributes</div>}
      >
        <div className={classes.detailContainer}>
          {attributes?.map((attr, index) => (
            <div key={index} className={classes.rowCard}>
              <div className={classes.rowKey}>
                {attr?.trait_type.split('_')?.join(' ')}
              </div>
              <div className={classes.rowValue}>
                {attr?.display_type === 'date'
                  ? new Date(attr?.value * 1000).toDateString()
                  : attr?.value}
              </div>
            </div>
          ))}
        </div>
      </Accordion>
    </div>
  );
};

export default Attributes;
